/**
 * Heights of the fixed chrome stacked around the dashboard board, in pixels.
 *
 * The board needs a definite height -- its rows are `1fr`, so a content-sized
 * parent gives them nothing to divide up -- which it gets by subtracting this
 * chrome from the viewport. Every height in the subtraction lives here, and is
 * applied from here, because the alternative had already broken: the header
 * shrank 96px -> 64px -> 48px while the board's reservation went only
 * 112px -> 96px, leaving a 16px dead band under the board (WEBV3-256).
 */

/** `Header`'s row in `BasePage`. */
export const HEADER_HEIGHT_PX = 48;

/** `Footer`'s row in `BasePage`. */
export const FOOTER_HEIGHT_PX = 16;

/** Inset on the board's wrapper in `Dashboard`, per side. */
export const BOARD_WRAPPER_PADDING_PX = 8;

/** Viewport height the board must leave to everything around it. */
export const BOARD_RESERVED_HEIGHT_PX =
  HEADER_HEIGHT_PX + FOOTER_HEIGHT_PX + 2 * BOARD_WRAPPER_PADDING_PX;

/** Definite height for the board's grid. */
export const BOARD_HEIGHT_CSS = `calc(100vh - ${BOARD_RESERVED_HEIGHT_PX}px)`;
